
























































































import {
  WeightDimenstions,
  LoadDimensionsFilters
} from './models/load-dimensions-filters-model'
import isObject from 'lodash/isObject'
import MinMaxRangeFields from './MinMaxRangeFields.vue'

const weightProperites = {
  maxWeight: null,
  minWeight: null
}
const defaultLoadDimensionsFilters = {
  maxHeight: null,
  maxWidth: null,
  maxLength: null,
  weight: { ...weightProperites }
}

export default {
  components: { MinMaxRangeFields },
  directives: {
    'click-outside': {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      isOpened: false,
      selectedFiltersNumber: 0,
      loadDimensions: defaultLoadDimensionsFilters as LoadDimensionsFilters
    }
  },
  computed: {
    filtersWithValues(): Array<LoadDimensionsFilters> {
      return Object.values<LoadDimensionsFilters>(this.loadDimensions).filter(
        item => item
      )
    },
    selectedFilters(): Array<boolean> {
      return this.filtersWithValues.filter((item: number | WeightDimenstions) => {
        if (isObject(item)) {
          return this.hasWeightFilter(item)
        }
        return true
      })
    }
  },
  watch: {
    value(value): void {
      this.loadDimensions = value
      this.setSelectedFiltersNumber()
    }
  },
  methods: {
    hideFilters(): void {
      this.isOpened = false
      this.setSelectedFiltersNumber()
    },
    setSelectedFiltersNumber(): void {
      this.selectedFiltersNumber = this.selectedFilters.length
    },
    clearAll(): void {
      defaultLoadDimensionsFilters.weight = { ...weightProperites }
      this.loadDimensions = { ...defaultLoadDimensionsFilters }
      this.$emit('input', this.loadDimensions)
    },
    hasWeightFilter(obj: WeightDimenstions): boolean {
      return Boolean(obj?.maxWeight || obj?.minWeight)
    },
    manageFiltersDisplaying(): void {
      this.isOpened = !this.isOpened
      this.setSelectedFiltersNumber()
    }
  }
}
